import { render, staticRenderFns } from "./ResourceInstanceControl.vue?vue&type=template&id=b564e86e&"
import script from "./ResourceInstanceControl.vue?vue&type=script&lang=js&"
export * from "./ResourceInstanceControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports